import React from "react";

import CmsPreviewShell from "./CmsPreviewShell";
import mockData from "./mockData.json";

import type { CmsComponentProps, GalleryMock } from "./types";

const GalleryComponent: React.FC<CmsComponentProps> = ({ title, layout, items: userItems }) => {
  const items: GalleryMock[] =
    userItems && userItems.length > 0
      ? userItems
          .filter((i) => i.is_active !== false)
          .map((i, idx) => ({
            id: idx,
            img: i.img ?? "",
            caption: i.caption ?? "",
            author: i.author ?? "",
            sourceType: i.source_type ?? "internal",
            tagLabels: i.tag_labels ?? [],
          }))
      : (mockData.gallery as GalleryMock[]);

  return (
    <CmsPreviewShell title={title}>
      <div className={`cms-gallery cms-gallery--${layout}`}>
        {items.map((item) => (
          <div key={item.id} className="cms-gallery__item">
            <div className="cms-gallery__thumb">
              {item.img ? <img src={item.img} alt={item.caption} /> : <div className="cms-gallery__placeholder">이미지 없음</div>}
              <div className="cms-gallery__overlay">
                {item.caption && <p className="cms-gallery__caption">{item.caption}</p>}
                {item.author && <span className="cms-gallery__author">{item.author}</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </CmsPreviewShell>
  );
};

export default GalleryComponent;
